module.exports = __webpack_public_path__ + "img/gachita_2.ff52b9f0.png";